var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettingsGearFilled = function SvgSettingsGearFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.607 18a3 3 0 0 0 4.097 1.102l.003-.002.445-.257A9 9 0 0 0 9 20.487V21a3 3 0 0 0 6 0v-.513a9 9 0 0 0 2.848-1.646l.447.258a3.002 3.002 0 0 0 3-5.2l-.444-.256a9.1 9.1 0 0 0 0-3.29l.444-.256a3.002 3.002 0 0 0-3-5.2l-.445.257A9 9 0 0 0 15 3.513V3a3 3 0 0 0-6 0v.513a9 9 0 0 0-2.848 1.646L5.705 4.9a3.002 3.002 0 1 0-3 5.2l.444.256a9.1 9.1 0 0 0 0 3.29l-.444.256A3.006 3.006 0 0 0 1.607 18M12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8"
  })));
};
export default SvgSettingsGearFilled;